import Result from '../../components/result/Result';
import DetailList from '../../components/tool/DetailList';
import AStepItem from '../../components/tool/AStepItem';
var AStepItemGroup = AStepItem.Group;
var DetailListItem = DetailList.Item;
export default {
  name: 'Success',
  components: {
    AStepItemGroup: AStepItemGroup,
    AStepItem: AStepItem,
    DetailListItem: DetailListItem,
    DetailList: DetailList,
    Result: Result
  },
  data: function data() {
    return {
      title: '提交成功',
      description: '提交结果页用于反馈一系列操作任务的处理结果，\n' + ' 如果仅是简单操作，使用 Message 全局提示反馈即可。\n' + ' 本文字区域可以展示简单的补充说明，如果有类似展示\n' + ' “单据”的需求，下面这个灰色区域可以呈现比较复杂的内容。'
    };
  },
  methods: {
    print: function print() {
      window.print();
    }
  }
};